module.exports = __webpack_public_path__ + "img/cooperate7.39e7ca9d.png";